import {resolveOutlinePageRange, type OutlineEntry, type PDFStructure} from '@reados/contracts';

export function outlineBookPageLabel(structure: PDFStructure, entry: OutlineEntry): string {
  return structure.labels.find(item => item.pageNumber === entry.pageNumber)?.label || entry.pageLabel || String(entry.pageNumber);
}

/** Edit the stored start binding; chapter end pages are derived from hierarchy. */
export function resolveOutlineDraft(structure: PDFStructure, labels: Record<string, string>): OutlineEntry[] {
  return structure.outline.map(entry => {
    const label = (labels[entry.id] ?? outlineBookPageLabel(structure, entry)).trim();
    const matches = structure.labels.filter(item => item.label === label);
    const unchanged = label === outlineBookPageLabel(structure, entry);
    const match = unchanged ? matches.find(item => item.pageNumber === entry.pageNumber) : undefined;
    if (!match && matches.length !== 1) {
      throw new Error(matches.length ? `书本页码“${label}”对应多个 PDF 页。` : `找不到书本页码“${label}”。`);
    }
    return {...entry, title: entry.title.trim(), pageNumber: (match || matches[0]).pageNumber, pageLabel: label};
  });
}

export function outlinePageRangeText(structure: PDFStructure, entryId: string): string {
  return resolveOutlinePageRange(entryId, structure.outline, structure.pageCount, structure.labels)?.displayText ?? '—';
}
